/** Hosted-site Clerk. Absent on a self-hosted install, which must not load the auth chunk. */
export function clerkPublishableKey(): string {
	const key = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
	return typeof key === "string" ? key.trim() : "";
}

export function clerkEnabled(): boolean {
	const key = clerkPublishableKey();
	return key.length > 0 && key !== "YOUR_PUBLISHABLE_KEY";
}
